// extracted by mini-css-extract-plugin
export default {"rowDetailsItem":"YVi5TQ4IPM06_TQwt2HD","comma":"W5eXPNPpFjVYtMOed8Uj"};